export default __webpack_public_path__ + "static/media/play_store.27624d3d.svg";